import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import Datetime from 'react-datetime';
import moment from 'moment';

const EMAILS_PER_HOUR = 500;
const MINIMUM_WINDOW_MINUTES = 60;

export function sendWindowMinutes(recipientCount) {
  return Math.max(MINIMUM_WINDOW_MINUTES, Math.ceil(recipientCount / EMAILS_PER_HOUR * 60));
}

export function sendByDate(launchDate, recipientCount) {
  if (!moment.isMoment(launchDate) || !launchDate.isValid()) return null;
  return launchDate.clone().add(sendWindowMinutes(recipientCount), 'minutes');
}

export function adjustExpiredLaunch(launchDate, now = moment()) {
  if (!moment.isMoment(launchDate) || !launchDate.isValid()) return { launchDate, adjusted: false };
  const adjusted = !launchDate.isAfter(now);
  return { launchDate: adjusted ? now.clone().add(5, 'minutes') : launchDate.clone(), adjusted };
}

// Forms show the browser's local time; the API receives the same instant in UTC.
export function campaignTimeZone(date) {
  const name = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offset = `UTC${(moment.isMoment(date) && date.isValid() ? date : moment()).format('Z')}`;
  return name ? `${name} (${offset})` : offset;
}

export default function CampaignScheduleFields({ launchDate, recipientCount, error, onLaunchChange, t }) {
  const sendBy = sendByDate(launchDate, recipientCount);
  return <FormGroup>
    <Row>
      <Col sm={6}>
        <Label for="launch_date">{t('simulation_wizard.schedule_launch')}</Label>
        <Datetime inputProps={{ id: 'launch_date', name: 'launch_date' }} value={launchDate} onChange={onLaunchChange} />
        <span style={{ color: "red" }}>{error}</span>
      </Col>
      <Col sm={6}>
        <Label for="send_by_date">{t('simulation_wizard.schedule_send_by')}</Label>
        <Input id="send_by_date" name="send_by_date" readOnly value={sendBy ? sendBy.format('L LT') : ''} />
      </Col>
    </Row>
    <small className="form-text text-muted">{t('simulation_wizard.schedule_rate')}</small>
    <small className="form-text text-muted">{t('simulation_wizard.schedule_timezone', { zone: campaignTimeZone(launchDate) })}</small>
  </FormGroup>;
}
